import { TextField } from "@mui/material";
import type { DisplayOnlyTextFieldProps } from "../../types";

function DisplayOnlyTextField({
  id,
  label,
  value,
  error = false,
  helperText,
}: DisplayOnlyTextFieldProps) {
  return (
    <TextField
      id={id}
      label={label}
      value={value}
      size="small"
      multiline
      error={error}
      helperText={helperText}
      slotProps={{
        input: {
          readOnly: true,
        },
        htmlInput: {
          tabIndex: -1,
          "aria-readonly": true,
          style: {
            caretColor: "transparent",
            pointerEvents: "none",
            userSelect: "none",
          },
        },
      }}
      sx={{
        paddingBottom: 2,
        overflowWrap: "anywhere",
        whiteSpace: "pre-line",
        pointerEvents: "none",
        userSelect: "none",
        "& input, & textarea": {
          caretColor: "transparent",
          userSelect: "none",
        },
      }}
    />
  );
}

export default DisplayOnlyTextField;
